import styles from "./ProgressBar.module.scss";

interface ProgressBarProps {
  progress: number;
}

const ProgressBar = ({ progress }: ProgressBarProps) => {
  return (
    <div className={styles.wrapper}>
      <div className="bar" style={{ width: `calc(${Math.round(100 * progress)}% - 64px)` }} />
    </div>
  );
};

export default ProgressBar;
